const TELEGRAM_WEB_APP_SCRIPT_SRC = 'https://telegram.org/js/telegram-web-app.js';

let telegramWebAppScriptPromise: Promise<void> | null = null;

const waitForExistingScript = (script: HTMLScriptElement): Promise<void> =>
  new Promise((resolve, reject) => {
    const handleLoad = () => {
      cleanup();
      resolve();
    };

    const handleError = () => {
      cleanup();
      reject(new Error('Failed to load Telegram Web App script'));
    };

    const cleanup = () => {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);
  });

export const loadTelegramWebAppScript = async (): Promise<void> => {
  if (typeof window === 'undefined' || window.Telegram?.WebApp != null) {
    return;
  }

  if (telegramWebAppScriptPromise) {
    return telegramWebAppScriptPromise;
  }

  const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${TELEGRAM_WEB_APP_SCRIPT_SRC}"]`);

  telegramWebAppScriptPromise =
    existingScript ?
      waitForExistingScript(existingScript)
    : new Promise((resolve, reject) => {
        const script = document.createElement('script');

        script.async = true;
        script.src = TELEGRAM_WEB_APP_SCRIPT_SRC;

        script.addEventListener('load', () => resolve(), { once: true });
        script.addEventListener('error', () => reject(new Error('Failed to load Telegram Web App script')), {
          once: true,
        });

        document.head.append(script);
      });

  try {
    await telegramWebAppScriptPromise;
  } catch (error) {
    telegramWebAppScriptPromise = null;
    throw error;
  }
};
